/**
 * Loader Button Web Component
 * A button that displays a loading spinner when busy
 * Usage: <button is="loader-button" type="submit">Submit</button>
 * Set aria-busy="true" to show spinner, aria-busy="false" to hide
 */

globalThis.EzupLoaderButton = globalThis.EzupLoaderButton || class LoaderButton extends HTMLButtonElement {
  static get observedAttributes() {
    return ['aria-busy'];
  }

  constructor() {
    super();

    // Auto-activate on submit for forms (only for default forms, not custom handlers)
    this.addEventListener('click', (event) => {
      if (
        this.type === 'submit' &&
        this.form &&
        this.form.checkValidity() &&
        !this.form.hasAttribute('is') &&
        !this.form.hasAttribute('data-use-custom-handler')
      ) {
        // Safari requires special handling
        if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
          event.preventDefault();
          this.setAttribute('aria-busy', 'true');
          setTimeout(() => this.form.submit(), 250);
        } else {
          this.setAttribute('aria-busy', 'true');
        }
      }
    });
  }

  connectedCallback() {
    // Wait for next tick to ensure DOM is ready
    setTimeout(() => this._prepareButton(), 0);
  }

  disconnectedCallback() {
    if (this.originalContent) {
      this.innerHTML = this.originalContent;
    }
  }

  attributeChangedCallback(property, oldValue, newValue) {
    if (property === 'aria-busy' && oldValue !== newValue) {
      if (newValue === 'true') {
        this._showLoading();
      } else if (newValue === 'false' || newValue === null) {
        this._hideLoading();
      }
    }
  }

  _prepareButton() {
    // Skip if already prepared
    if (this.querySelector('.loader-button__content')) {
      return;
    }

    this.originalContent = this.innerHTML;

    // Add wrapper structure
    this.innerHTML = `
      <span class="loader-button__content">
        <span class="loader-button__text">${this.originalContent}</span>
        <span class="loader-button__spinner" aria-hidden="true"></span>
      </span>
    `;

    this.contentWrapper = this.querySelector('.loader-button__content');
    this.textElement = this.querySelector('.loader-button__text');
    this.spinnerElement = this.querySelector('.loader-button__spinner');

    // Clean up on page hide
    window.addEventListener('pagehide', () => this.removeAttribute('aria-busy'));
  }

  _showLoading() {
    if (!this.contentWrapper) {
      return;
    }

    // Add loading class for CSS transitions
    this.classList.add('is-loading');

    // Disable button after a tiny delay to allow form submission to proceed
    setTimeout(() => {
      this.disabled = true;
    }, 50);
  }

  _hideLoading() {
    if (!this.contentWrapper) {
      return;
    }

    // Enable button
    this.disabled = false;

    // Remove loading class
    this.classList.remove('is-loading');
  }
}

// Register the loader-button web component
if (!customElements.get('loader-button')) {
  customElements.define('loader-button', globalThis.EzupLoaderButton, { extends: 'button' });
}
